<template>
  <div class="menu">
	<div style="margin: 10px 0px 0px 15px; font-weight: bold; letter-spacing: 3px;">{{ $t('main.storeclass') }}</div>
	<div class='menu-bgimg'></div>
	<div class='menu-wrapper'>
		<div class='menu-itemlist clear-fix'>
			<div class="menu-item" @click="goPointsgoods">
			  <i class="iconfont"><img class="menu-item-icon" src="../../../assets/image/home/jifen.svg" /></i>
			  <span class="menu-item-title">{{ $t('tool.points') }}</span>
			</div>
			<!-- <div class="menu-item"  v-for="(item, index) in menu" :key="index" @click="jump('storeclass', item.storeclass_id)">
			  <i class="iconfont"><img class="menu-item-icon" :src="item.img" /></i>
			  <span class="menu-item-title">{{item.title}}</span>
			</div> -->
			<div class="menu-item"  v-for="(item, index) in items" :key="index" @click="jump('storeclass', index)">
			  <i class="iconfont"><img class="menu-item-icon" v-lazy="item.storeclass_pic" /></i>
			  <span class="menu-item-title">{{item.storeclass_name}}</span>
			</div>
		</div>
	</div>

  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { Toast } from 'mint-ui'

export default {
	data() {
		return {
		}
	},
  name: 'HomeWaimaiMenu',
  props: ['items'],
  computed: {
    ...mapState({
      isOnline: state => state.member.isOnline
    })
  },
  methods: {
	...mapMutations({
		resetCommonStoreList: 'resetCommonStoreList'
    }),
    showLogin () {
      this.$router.push({ name: 'HomeMemberLogin' })
    },
    goPointsgoods () {
      if (!this.isOnline) {
        Toast(this.$t('guest.need_more_please_login'))
        return
      }
      this.$router.push({ 'name': 'HomePointsgoods' })
    },
    goArticleclass () {
      this.$router.push({ 'name': 'HomeArticleclass' })
    },
    myOrder () {
      if (this.isOnline) {
        this.$router.push({
          name: 'MemberOrderList'
        })
      } else {
        this.showLogin()
      }
    },
    goFuwuClass () {
      this.$router.push({
        name: 'FuwuClass'
      })
    },
    goFuwuOrganizationList () {
      this.$router.push({
        name: 'FuwuOrganizationList'
      })
    },
    // 跳转界面
    jump (type, index) {
      if (type === 'storeclass') {
		this.resetCommonStoreList()
        this.$router.push({ name: 'HomeStorelist', query: { category: this.items[index].storeclass_id, category_title: this.items[index].storeclass_name } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .menu {
    overflow: hidden;
    justify-content: space-around;
    position: relative;
    margin-bottom:$modelSpace;
	.menu-bgimg{
		position: absolute;
		z-index: 0;
		// background: #f4c41e;
		width: 100%;
		height: 8rem;
		border-radius: 0 0 .8rem .8rem;
	}
	.menu-wrapper{
		box-sizing: border-box;
		padding-left:.7rem;
		padding-right:.7rem;
		width: 100%;
		position: relative;
		// padding-top: 1rem;
		.menu-itemlist{
			background: #fff;
			padding: 1rem 0 0;
			border-radius: .5rem;
			.menu-item {
			  width:20%;
			  padding:0 .7rem;
			  padding-bottom:20%;
			  height: 0;
			  box-sizing: border-box;
			  text-align:center;
			  position: relative;
			  float: left;
			  .iconfont{
			    position: absolute;
			    margin:auto;
			    top: 0;
			    bottom:1.4rem;
			    left:.7rem;
			    right:.7rem;
			    font-size:0;
			    color:#fff;
			    overflow: hidden;
			    display:block;
			    text-align: center;
			  }
			  .menu-item-icon {
			    width: 100%;
			    height: 100%;
			    overflow: hidden;
			  }
			  .menu-item-title {
			    position: absolute;
			    left:0;
			    right:0;
			    bottom:.6rem;
			    display:block;
			    color: $formInputColor;
			    font-size:$fontSize;
			    overflow: hidden;
			    text-overflow: ellipsis;
			    white-space: nowrap;
			  }
			}
		}

	}

  }
.bg-1{background-image: linear-gradient(to bottom , #d69dcc,#e8198b );}
.bg-2{background-image: linear-gradient(to bottom , #04befe,#4481eb );}
.bg-3{background-image: linear-gradient(to bottom , #cc208e,#6713d2 );}
.bg-4{background-image: linear-gradient(to bottom , #ff9a44,#fc6076 );}
.bg-5{background-image: linear-gradient(to bottom , #00ecbc,#007adf );}
.bg-6{background-image: linear-gradient(to bottom , #ff8177,#b12a5b );}

</style>
